// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserSexOther_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM4 7C5.65685 7 7 5.65685 7 4C7 2.34315 5.65685 1 4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 7C9.10457 7 10 6.10457 10 5 10 3.89543 9.10457 3 8 3 6.89543 3 6 3.89543 6 5 6 6.10457 6.89543 7 8 7ZM8 9C10.2091 9 12 7.20914 12 5 12 2.79086 10.2091 1 8 1 5.79086 1 4 2.79086 4 5 4 7.20914 5.79086 9 8 9ZM8 13.0011C8.41421 13.0011 8.75 12.6653 8.75 12.2511 8.75 11.8369 8.41421 11.5011 8 11.5011 7.58579 11.5011 7.25 11.8369 7.25 12.2511 7.25 12.6653 7.58579 13.0011 8 13.0011ZM8 15.0011C9.51878 15.0011 10.75 13.7699 10.75 12.2511 10.75 10.7323 9.51878 9.5011 8 9.5011 6.48122 9.5011 5.25 10.7323 5.25 12.2511 5.25 13.7699 6.48122 15.0011 8 15.0011Z" class="svg-bg"/>
  <path d="M7 8H9V11H7V8Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 13.9291C16.3923 13.4439 19 10.5265 19 7C19 3.13401 15.866 0 12 0C8.13401 0 5 3.13401 5 7C5 10.5265 7.60771 13.4439 11 13.9291V16.126C9.27477 16.5701 8 18.1362 8 20C8 22.2091 9.79086 24 12 24C14.2091 24 16 22.2091 16 20C16 18.1362 14.7252 16.5701 13 16.126V13.9291ZM12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18ZM12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserSexOther is a generated icon component.
 */
let IconUserSexOther = IconUserSexOther_1 = class IconUserSexOther extends IconBaseElement {
    render() {
        return html `${IconUserSexOther_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserSexOther.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserSexOther = IconUserSexOther_1 = __decorate([
    customElement('zui-icon-user-sex-other')
], IconUserSexOther);
export { IconUserSexOther };
